import React from "react";
import ContactDetails from "../../../_components/Contacts/ContactDetails";
import {
    getSupplierById, updateSupplier, createSupplier,
    getSupplierCompanyNames,
} from "../../../_services/contact.service";
import { isPurchasingUser, isSuperAdmin, canAccessAccounting } from '../../../utils/roleConstants';


export default function SupplierDetails() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Keep detail editing aligned with the Supplier list's exact writer policy.
    const viewOnly = !(isSuperAdmin(user) || isPurchasingUser(user) || canAccessAccounting(user));
    return (
        <ContactDetails
            type="Supplier"
            fetchById={getSupplierById}
            updateItem={updateSupplier}
            createItem={createSupplier}
            fetchCompanyNames={getSupplierCompanyNames}
            viewOnly={viewOnly}
        />
    );
}